<template functional>
    <div class="security-info container">
        <div class="row">
            <div class="primary col-12 text-center text-uppercase mb-lg-2">
                <IconSvg filepath="shield.svg" class="shield" />
                {{ parent.$t('Checkout.security.important') }}
            </div>
            <div class="col-12 col-sm-6 text-center text-sm-right">
                <IconSvg filepath="tick.svg" />
                {{ parent.$t('Checkout.security.connection') }}
            </div>
            <div class="col-12 col-sm-6 text-center text-sm-left">
                <IconSvg filepath="tick.svg" />
                {{ parent.$t('Checkout.security.data') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SecurityInfo'
};
</script>

<style scoped lang="scss">
@use '@/styles/variables';
@use 'sass:map';

.security-info {
    .icon-svg {
        color: map.get(variables.$inputs, 'filled-color');
        margin-right: 5px;

        &.shield {
            font-size: 26px;
        }
    }

    .primary {
        font-weight: bold;
    }
}
</style>
